// eslint-disable-next-line no-underscore-dangle
type WindowWith1Flow = Window & {
  _1flow?: (
    eventType: 'track' | 'identify',
    eventName: string,
    params: Record<string, unknown>,
  ) => void | undefined;
};

// eslint-disable-next-line no-underscore-dangle
const log1flow = (window as WindowWith1Flow)._1flow;

export const log1flowEvent = (
  eventName: string,
  params: Record<string, unknown>,
) => {
  log1flow?.('track', eventName, { origin: 'WEB', ...params });
};

export const logUser = (userId: string, params: Record<string, unknown>) => {
  log1flow?.('identify', userId, params);
};
